/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ui_SelectedInputs */

const en_ui_selected = /** @type {(inputs: Ui_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

/** @type {(inputs: Ui_SelectedInputs) => LocalizedString} */
const ar_ui_selected = en_ui_selected;

/** @type {(inputs: Ui_SelectedInputs) => LocalizedString} */
const he_ui_selected = en_ui_selected;

/** @type {(inputs: Ui_SelectedInputs) => LocalizedString} */
const ur_ui_selected = en_ui_selected;

/** @type {(inputs: Ui_SelectedInputs) => LocalizedString} */
const es_ui_selected = en_ui_selected;

/** @type {(inputs: Ui_SelectedInputs) => LocalizedString} */
const fr_ui_selected = en_ui_selected;

/** @type {(inputs: Ui_SelectedInputs) => LocalizedString} */
const de_ui_selected = en_ui_selected;

/** @type {(inputs: Ui_SelectedInputs) => LocalizedString} */
const pt_ui_selected = en_ui_selected;

/** @type {(inputs: Ui_SelectedInputs) => LocalizedString} */
const hi_ui_selected = en_ui_selected;

/** @type {(inputs: Ui_SelectedInputs) => LocalizedString} */
const bn_ui_selected = en_ui_selected;

/**
* | output |
* | --- |
* | "{count} selected" |
*
* @param {Ui_SelectedInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const ui_selected = /** @type {((inputs: Ui_SelectedInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_SelectedInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ui_selected(inputs)
	if (locale === "he") return he_ui_selected(inputs)
	if (locale === "ur") return ur_ui_selected(inputs)
	if (locale === "es") return es_ui_selected(inputs)
	if (locale === "fr") return fr_ui_selected(inputs)
	if (locale === "de") return de_ui_selected(inputs)
	if (locale === "pt") return pt_ui_selected(inputs)
	if (locale === "hi") return hi_ui_selected(inputs)
	if (locale === "bn") return bn_ui_selected(inputs)
	return en_ui_selected(inputs)
});